import { Panel, RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { useProjects } from '@/features/projects/projects.hooks';
import ProjectTable from '@/features/projects/projects.table';

const ProjectsTableWithData = ({ basePath }: { basePath: string }) => (
  <ProjectTable basePath={basePath} {...useProjects()} />
);

export const ProjectsPanel = ({
  params,
  path,
  basePath,
  ...panelProps
}: RoutedPanelProps) => {
  return (
    <Panel {...panelProps}>
      {/* ???: does this pattern prevent errors from propagating past Panel? */}
      <ProjectsTableWithData basePath={basePath} />
    </Panel>
  );
};
